module.exports = __webpack_public_path__ + "static/media/calendar.cf5fe201.svg";